export const engagementReport = {
  company: {
    id: 181,
    name: "Precision Talent Solutions  |  Internal ",
    address_line_1: "1230 Peachtree St NE",
    address_line_2: "3540",
    city: "Atlanta",
    state_provence: "GA",
    zip: "30309",
    country: "USA",
    manager_count: 5,
    employee_count: 37,
    logo_url: "61c8546c3b581fdb4c17e2eb2e1915bc.png",
    shortname: "pts",
    hide_invites: false,
    coach_report: true,
    select_report: true,
    medical_report: false,
    clinical_report: false,
    fpf_very_low_limit: 29.5,
    fpf_low_limit: 44.5,
    fpf_moderate_limit: 64.5,
    fpf_high_limit: 79.5,
    cos_very_low_limit: 29.5,
    cos_low_limit: 44.5,
    cos_moderate_limit: 64.5,
    cos_high_limit: 79.5,
    cog_cutoff: 35.0,
    available_templates: [],
  },
  survey_name: "PTS 2023 Engagement Survey ",
  questions: [
    {
      id: 965308,
      text: "Precision Talent Solutions  |  Internal  promotes a collaborative work culture.",
      factor: 0,
      dimension: 0,
      position: 1,
    },
    {
      id: 965309,
      text: "I trust the Precision Talent Solutions  |  Internal  organization. ",
      factor: 0,
      dimension: 0,
      position: 2,
      descriptor: 0,
    },
    {
      id: 965310,
      text: "Precision Talent Solutions  |  Internal  is committed to its employees.",
      factor: 0,
      dimension: 0,
      position: 3,
    },
    {
      id: 965311,
      text: "Precision Talent Solutions  |  Internal  provides realistic expectations for its employees.",
      factor: 1,
      dimension: 0,
      position: 4,
      descriptor: 0,
    },
    {
      id: 965312,
      text: "Precision Talent Solutions  |  Internal  managers/supervisors are effective in providing support to employees.",
      factor: 1,
      dimension: 0,
      position: 5,
      descriptor: 0,
    },
    {
      id: 965313,
      text: "The Precision Talent Solutions  |  Internal  culture brings out the best in people.",
      factor: 1,
      dimension: 0,
      position: 6,
    },
    {
      id: 965314,
      text: "Talent is recognized as a competitive advantage by Precision Talent Solutions  |  Internal .",
      factor: 2,
      dimension: 0,
      position: 7,
    },
    {
      id: 965315,
      text: "I am provided regular feedback from my manager.",
      factor: 2,
      dimension: 0,
      position: 8,
    },
    {
      id: 965316,
      text: "Precision Talent Solutions  |  Internal  is genuinely interested in my professional development.",
      factor: 2,
      dimension: 0,
      position: 9,
    },
    {
      id: 965317,
      text: "My team collaborates effectively.",
      factor: 0,
      dimension: 1,
      position: 10,
      descriptor: 0,
    },
    {
      id: 965318,
      text: "I trust my manager/supervisor.",
      factor: 0,
      dimension: 1,
      position: 11,
      descriptor: 0,
    },
    {
      id: 965319,
      text: "My teammates are supportive of one another.  ",
      factor: 0,
      dimension: 1,
      position: 12,
      descriptor: 0,
    },
    {
      id: 965320,
      text: "My manager/supervisor lets me know how I am performing.",
      factor: 1,
      dimension: 1,
      position: 13,
      descriptor: 0,
    },
    {
      id: 965321,
      text: "My manager is supportive of my efforts.",
      factor: 1,
      dimension: 1,
      position: 14,
    },
    {
      id: 965322,
      text: "My manager/supervisor gives me the latitude to pursue excellence in my work. ",
      factor: 1,
      dimension: 1,
      position: 15,
      descriptor: 0,
    },
    {
      id: 965323,
      text: "Precision Talent Solutions  |  Internal  rewards its employees.",
      factor: 2,
      dimension: 1,
      position: 16,
    },
    {
      id: 965324,
      text: "I know where I stand with my managers/supervisors.",
      factor: 2,
      dimension: 1,
      position: 17,
      descriptor: 0,
    },
    {
      id: 965325,
      text: "My professional development is given proper attention by my manager.",
      factor: 2,
      dimension: 1,
      position: 18,
    },
    {
      id: 965326,
      text: "I enjoy working with my team. ",
      factor: 0,
      dimension: 2,
      position: 19,
      descriptor: 0,
    },
    {
      id: 965327,
      text: "I trust my team.  ",
      factor: 0,
      dimension: 2,
      position: 20,
      descriptor: 0,
    },
    {
      id: 965328,
      text: "Work relationships enhance my level of commitment.",
      factor: 0,
      dimension: 2,
      position: 21,
    },
    {
      id: 965329,
      text: "I am secure in my position.",
      factor: 1,
      dimension: 2,
      position: 22,
    },
    {
      id: 965330,
      text: "I know I am valued at work.",
      factor: 1,
      dimension: 2,
      position: 23,
      descriptor: 0,
    },
    {
      id: 965331,
      text: "I am free to share my opinions with my colleagues.",
      factor: 1,
      dimension: 2,
      position: 24,
    },
    {
      id: 965332,
      text: "I am recognized for my good work. ",
      factor: 2,
      dimension: 2,
      position: 25,
      descriptor: 0,
    },
    {
      id: 965333,
      text: "I know when I have made a difference.",
      factor: 2,
      dimension: 2,
      position: 26,
    },
    {
      id: 965334,
      text: "I support and contribute to the development of others.",
      factor: 2,
      dimension: 2,
      position: 27,
      descriptor: 0,
    },
    {
      id: 965335,
      text: "Precision Talent Solutions  |  Internal  provides me with the necessary training to do my job.",
      factor: 4,
      dimension: 0,
      position: 28,
      descriptor: 0,
    },
    {
      id: 965336,
      text: "Precision Talent Solutions  |  Internal  provides me with the necessary tools and materials to do my job.",
      factor: 4,
      dimension: 0,
      position: 29,
      descriptor: 0,
    },
    {
      id: 965337,
      text: "Precision Talent Solutions  |  Internal  implements effective processes.",
      factor: 4,
      dimension: 0,
      position: 30,
    },
    {
      id: 965338,
      text: "My manager/supervisor recommends opportunities for me.",
      factor: 4,
      dimension: 1,
      position: 31,
      descriptor: 0,
    },
    {
      id: 965339,
      text: "I am asked what resources are needed for my job.",
      factor: 4,
      dimension: 1,
      position: 32,
    },
    {
      id: 965340,
      text: "I often play a part in process improvement.",
      factor: 4,
      dimension: 1,
      position: 33,
    },
    {
      id: 965341,
      text: "I am trained to perform my job effectively.",
      factor: 4,
      dimension: 2,
      position: 34,
    },
    {
      id: 965342,
      text: "I feel I have the proper equipment required to do my job well.",
      factor: 4,
      dimension: 2,
      position: 35,
    },
    {
      id: 965343,
      text: "I am encouraged to create better ways to do my job.",
      factor: 4,
      dimension: 2,
      position: 36,
    },
    {
      id: 965344,
      text: "Precision Talent Solutions  |  Internal  does a good job of communicating decisions.",
      factor: 3,
      dimension: 0,
      position: 37,
    },
    {
      id: 965345,
      text: "My manager and I maintain a clear understanding about how I am to perform my job.",
      factor: 3,
      dimension: 1,
      position: 38,
    },
    {
      id: 965346,
      text: "I feel comfortable when seeking information.  ",
      factor: 3,
      dimension: 2,
      position: 39,
      descriptor: 0,
    },
    {
      id: 965347,
      text: "Precision Talent Solutions  |  Internal  staffing levels are appropriate.",
      factor: 5,
      dimension: 0,
      position: 40,
    },
    {
      id: 965348,
      text: "My workload is manageable.",
      factor: 5,
      dimension: 1,
      position: 41,
    },
    {
      id: 965349,
      text: "I have sufficient time to deal with the demands of my job.",
      factor: 5,
      dimension: 2,
      position: 42,
    },
  ],
  employees: [
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 18,
        age: 50,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        {
          id: 969329,
          parent_id: 965308,
          respondant_comment: "",
          response_d: true,
        },
        {
          id: 969330,
          parent_id: 965309,
          respondant_comment:
            "Our organization is built light on policies \u0026 procedures and relies heavily on trust and responsibility. ",
          response_e: true,
        },
        {
          id: 969331,
          parent_id: 965310,
          respondant_comment:
            "We have pretty good alignment across the organization because of our structure. There is more that can be done on the development side to build more for each person's future. ",
          response_d: true,
        },
        {
          id: 969332,
          parent_id: 965311,
          respondant_comment:
            "We do push are on our teams and have high expectations. Sometimes this can stretch our capacity, but we always overcome. ",
          response_d: true,
        },
        {
          id: 969333,
          parent_id: 965312,
          respondant_comment:
            "We have pivoted some roles from individual contributors to being team leaders. In some cases, we have not provided the right training for the new responsibilities. But we do our best to help and encourage our team. ",
          response_d: true,
        },
        {
          id: 969334,
          parent_id: 965313,
          respondant_comment:
            "For a commission-driven organization, we have good alignment and limited internal competition as we are all trying to reach the same goals. We have tried hard to build a family instead of a corporation. We give people the chance to succeed. ",
          response_e: true,
        },
        {
          id: 969335,
          parent_id: 965314,
          respondant_comment:
            "Talented people have room to grow without limitation. The cream rises to the top. ",
          response_e: true,
        },
        {
          id: 969336,
          parent_id: 965315,
          respondant_comment: "",
          response_c: true,
        },
        {
          id: 969337,
          parent_id: 965316,
          respondant_comment:
            "We have taken people with various skills and experienced and trained them to recruit the PTS Way. We are always training and trying to learn from each other. It could be better structured, but we are getting there. ",
          response_d: true,
        },
        {
          id: 969338,
          parent_id: 965317,
          respondant_comment:
            "We try to find the right balance between work and collaboration. Our tools are helping us to get better and more efficient. ",
          response_d: true,
        },
        { id: 969339, parent_id: 965318, response_d: true },
        { id: 969340, parent_id: 965319, response_d: true },
        { id: 969341, parent_id: 965320, response_d: true },
        { id: 969342, parent_id: 965321, response_d: true },
        { id: 969343, parent_id: 965322, response_d: true },
        {
          id: 969344,
          parent_id: 965323,
          respondant_comment:
            "The company did a discretionary bonus last year to reward the entire team. We provide training and appreciation, which is a great reward. ",
          response_d: true,
        },
        { id: 969345, parent_id: 965324, response_d: true },
        { id: 969346, parent_id: 965325, response_d: true },
        {
          id: 969347,
          parent_id: 965326,
          respondant_comment:
            "I really enjoy our different views and perspectives. ",
          response_e: true,
        },
        { id: 969348, parent_id: 965327, response_e: true },
        { id: 969349, parent_id: 965328, response_e: true },
        {
          id: 969350,
          parent_id: 965329,
          respondant_comment: "I control my own destiny in PTS. ",
          response_e: true,
        },
        { id: 969351, parent_id: 965330, response_e: true },
        { id: 969352, parent_id: 965331, response_e: true },
        { id: 969353, parent_id: 965332, response_e: true },
        {
          id: 969354,
          parent_id: 965333,
          respondant_comment:
            "It is great to see where we have been and the lives that we have changed. ",
          response_e: true,
        },
        {
          id: 969355,
          parent_id: 965334,
          respondant_comment: "I spend most of my time coaching. ",
          response_e: true,
        },
        {
          id: 969356,
          parent_id: 965335,
          respondant_comment:
            "We have introduced many new tools to make our business better (Bullhorn, LI Recruiter, BI tools, GovWin, etc.). We can always train more. ",
          response_d: true,
        },
        {
          id: 969357,
          parent_id: 965336,
          respondant_comment:
            "For a smallish recruiting company, we have invested heavily in tools and our infrastructure. ",
          response_e: true,
        },
        {
          id: 969358,
          parent_id: 965337,
          respondant_comment:
            "We have strong processes and are pretty good at implementing. ",
          response_d: true,
        },
        { id: 969359, parent_id: 965338, response_e: true },
        { id: 969360, parent_id: 965339, response_e: true },
        { id: 969361, parent_id: 965340, response_e: true },
        { id: 969362, parent_id: 965341, response_d: true },
        { id: 969363, parent_id: 965342, response_e: true },
        { id: 969364, parent_id: 965343, response_d: true },
        {
          id: 969365,
          parent_id: 965344,
          respondant_comment:
            'We can spend more time on explaining the "why" for decisions that are made. ',
          response_d: true,
        },
        { id: 969366, parent_id: 965345, response_e: true },
        { id: 969367, parent_id: 965346, response_e: true },
        {
          id: 969368,
          parent_id: 965347,
          respondant_comment:
            "This business tends to ebb and flow, so sometimes we have too much capacity...and sometimes we are stretched. ",
          response_c: true,
        },
        {
          id: 969369,
          parent_id: 965348,
          respondant_comment:
            "I tend to run at 110%, but that is how I like it. ",
          response_d: true,
        },
        { id: 969370, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 106,
        company_position_id: 519,
        tenure: 2,
        age: 40,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        {
          id: 969371,
          parent_id: 965308,
          respondant_comment:
            "I think there are more opportunities for people to reach out and request support, at all levels, but collaboration is always encouraged and productive when it happens.",
          response_d: true,
        },
        { id: 969372, parent_id: 965309, response_d: true },
        {
          id: 969373,
          parent_id: 965310,
          respondant_comment:
            "One area of commitment that should continue to be explored is personal growth/training.  We don't spend enough time trying to expand our employees skill sets as individuals.",
          response_d: true,
        },
        { id: 969374, parent_id: 965311, response_c: true },
        {
          id: 969375,
          parent_id: 965312,
          respondant_comment:
            'Support discussions should open with "how can I help?"  This would allow the employee to explain the issue in their own words and allows them to suggest potential solutions that can be implemented without support in the future.',
          response_c: true,
        },
        {
          id: 969376,
          parent_id: 965313,
          respondant_comment: "",
          response_c: true,
        },
        { id: 969377, parent_id: 965314, response_d: true },
        { id: 969378, parent_id: 965315, response_d: true },
        {
          id: 969379,
          parent_id: 965316,
          respondant_comment:
            "This is absolutely an area for improvement at all levels in the organization.",
          response_c: true,
        },
        { id: 969380, parent_id: 965317, response_d: true },
        { id: 969381, parent_id: 965318, response_d: true },
        { id: 969382, parent_id: 965319, response_d: true },
        { id: 969383, parent_id: 965320, response_d: true },
        { id: 969384, parent_id: 965321, response_d: true },
        { id: 969385, parent_id: 965322, response_d: true },
        {
          id: 969386,
          parent_id: 965323,
          respondant_comment:
            "The 10% bonus that was paid for 2022 clearly helped with retention and morale.  That does not, however, seem appropriate for all levels of the organization and future bonuses might need to be reviewed based on level of responsibility.",
          response_c: true,
        },
        { id: 969387, parent_id: 965324, response_d: true },
        { id: 969388, parent_id: 965325, response_b: true },
        { id: 969389, parent_id: 965326, response_d: true },
        { id: 969390, parent_id: 965327, response_d: true },
        { id: 969391, parent_id: 965328, response_d: true },
        { id: 969392, parent_id: 965329, response_e: true },
        {
          id: 969393,
          parent_id: 965330,
          respondant_comment:
            "There are always opportunities to reinforce value, at all levels.  PTS tends to start and/or focus on the negative and value can really only be expressed through the positive.",
          response_d: true,
        },
        { id: 969394, parent_id: 965331, response_d: true },
        {
          id: 969395,
          parent_id: 965332,
          respondant_comment: "We can do a better job celebrating small wins.",
          response_c: true,
        },
        { id: 969396, parent_id: 965333, response_c: true },
        { id: 969397, parent_id: 965334, response_d: true },
        { id: 969398, parent_id: 965335, response_c: true },
        { id: 969399, parent_id: 965336, response_d: true },
        { id: 969400, parent_id: 965337, response_c: true },
        {
          id: 969401,
          parent_id: 965338,
          respondant_comment: "",
          response_b: true,
        },
        { id: 969402, parent_id: 965339, response_c: true },
        { id: 969403, parent_id: 965340, response_e: true },
        { id: 969404, parent_id: 965341, response_d: true },
        { id: 969405, parent_id: 965342, response_d: true },
        {
          id: 969406,
          parent_id: 965343,
          respondant_comment:
            "Improvement tends to occur in select pockets and the broader team can be leveraged for improvement better.",
          response_c: true,
        },
        { id: 969407, parent_id: 965344, response_c: true },
        { id: 969408, parent_id: 965345, response_d: true },
        { id: 969409, parent_id: 965346, response_d: true },
        { id: 969410, parent_id: 965347, response_d: true },
        { id: 969411, parent_id: 965348, response_d: true },
        { id: 969412, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 106,
        company_position_id: 519,
        tenure: 5,
        age: 37,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 969413, parent_id: 965308, response_e: true },
        { id: 969414, parent_id: 965309, response_e: true },
        { id: 969415, parent_id: 965310, response_d: true },
        { id: 969416, parent_id: 965311, response_d: true },
        { id: 969417, parent_id: 965312, response_e: true },
        {
          id: 969418,
          parent_id: 965313,
          respondant_comment:
            "I think we need to find a better way to get employees to communicate more on calls and stay engaged throughout longer calls. Our team is quiet normally, yet they actually do have opinions on matters throughout team calls they share offline. ",
          response_d: true,
        },
        {
          id: 969419,
          parent_id: 965314,
          respondant_comment:
            "We can do more performance evaluations and give more feedback to employees for their professional growth.",
          response_d: true,
        },
        { id: 969420, parent_id: 965315, response_d: true },
        {
          id: 969421,
          parent_id: 965316,
          respondant_comment:
            "During performance reviews, as a company, we should ask employees in what areas they would want more training or certifications. ",
          response_d: true,
        },
        {
          id: 969422,
          parent_id: 965317,
          respondant_comment:
            'We need to better identifying "who\'s on first" when it comes to a task.',
          response_d: true,
        },
        {
          id: 969423,
          parent_id: 965318,
          respondant_comment: "",
          response_e: true,
        },
        { id: 969424, parent_id: 965319, response_e: true },
        { id: 969425, parent_id: 965320, response_e: true },
        { id: 969426, parent_id: 965321, response_d: true },
        { id: 969427, parent_id: 965322, response_d: true },
        {
          id: 969428,
          parent_id: 965323,
          respondant_comment:
            "I think we can come up with new rewards for top performers.",
          response_d: true,
        },
        { id: 969429, parent_id: 965324, response_e: true },
        { id: 969430, parent_id: 965325, response_d: true },
        { id: 969431, parent_id: 965326, response_e: true },
        { id: 969432, parent_id: 965327, response_e: true },
        { id: 969433, parent_id: 965328, response_e: true },
        { id: 969434, parent_id: 965329, response_e: true },
        {
          id: 969435,
          parent_id: 965330,
          respondant_comment:
            "I know I am valued, but I would like to hear it a little more often. ",
          response_d: true,
        },
        { id: 969436, parent_id: 965331, response_e: true },
        { id: 969437, parent_id: 965332, response_d: true },
        { id: 969438, parent_id: 965333, response_e: true },
        { id: 969439, parent_id: 965334, response_d: true },
        {
          id: 969440,
          parent_id: 965335,
          respondant_comment: "I would like more leadership training. ",
          response_d: true,
        },
        { id: 969441, parent_id: 965336, response_e: true },
        {
          id: 969442,
          parent_id: 965337,
          respondant_comment:
            "We have a good process for recruitment. The other departments need to formalize their processes. ",
          response_d: true,
        },
        { id: 969443, parent_id: 965338, response_e: true },
        { id: 969444, parent_id: 965339, response_d: true },
        { id: 969445, parent_id: 965340, response_e: true },
        { id: 969446, parent_id: 965341, response_d: true },
        { id: 969447, parent_id: 965342, response_e: true },
        {
          id: 969448,
          parent_id: 965343,
          respondant_comment: "",
          response_e: true,
        },
        {
          id: 969449,
          parent_id: 965344,
          respondant_comment:
            "I think we should do a better job of coming to a decision point and communicating it properly. ",
          response_c: true,
        },
        { id: 969450, parent_id: 965345, response_e: true },
        { id: 969451, parent_id: 965346, response_d: true },
        {
          id: 969452,
          parent_id: 965347,
          respondant_comment:
            "We are able to recognize when and where we need to grow. ",
          response_d: true,
        },
        {
          id: 969453,
          parent_id: 965348,
          respondant_comment: "It's getting better. ",
          response_d: true,
        },
        { id: 969454, parent_id: 965349, response_b: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 1,
        age: 25,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 969455, parent_id: 965308, response_d: true },
        { id: 969456, parent_id: 965309, response_d: true },
        { id: 969457, parent_id: 965310, response_e: true },
        { id: 969458, parent_id: 965311, response_c: true },
        { id: 969459, parent_id: 965312, response_d: true },
        {
          id: 969460,
          parent_id: 965313,
          respondant_comment:
            "We often overlook incompetence, inefficiency, and negligence to speed up the process or ensure a good product ",
          response_b: true,
        },
        { id: 969461, parent_id: 965314, response_d: true },
        { id: 969462, parent_id: 965315, response_a: true },
        { id: 969463, parent_id: 965316, response_b: true },
        { id: 969464, parent_id: 965317, response_b: true },
        { id: 969465, parent_id: 965318, response_e: true },
        { id: 969466, parent_id: 965319, response_e: true },
        { id: 969467, parent_id: 965320, response_c: true },
        { id: 969468, parent_id: 965321, response_e: true },
        { id: 969469, parent_id: 965322, response_e: true },
        { id: 969470, parent_id: 965323, response_e: true },
        { id: 969471, parent_id: 965324, response_e: true },
        { id: 969472, parent_id: 965325, response_d: true },
        { id: 969473, parent_id: 965326, response_b: true },
        { id: 969474, parent_id: 965327, response_b: true },
        { id: 969475, parent_id: 965328, response_d: true },
        { id: 969476, parent_id: 965329, response_e: true },
        { id: 969477, parent_id: 965330, response_b: true },
        { id: 969478, parent_id: 965331, response_a: true },
        { id: 969479, parent_id: 965332, response_b: true },
        { id: 969480, parent_id: 965333, response_b: true },
        { id: 969481, parent_id: 965334, response_e: true },
        { id: 969482, parent_id: 965335, response_a: true },
        { id: 969483, parent_id: 965336, response_d: true },
        { id: 969484, parent_id: 965337, response_a: true },
        { id: 969485, parent_id: 965338, response_d: true },
        { id: 969486, parent_id: 965339, response_c: true },
        { id: 969487, parent_id: 965340, response_d: true },
        { id: 969488, parent_id: 965341, response_b: true },
        { id: 969489, parent_id: 965342, response_b: true },
        { id: 969490, parent_id: 965343, response_d: true },
        { id: 969491, parent_id: 965344, response_b: true },
        { id: 969492, parent_id: 965345, response_d: true },
        { id: 969493, parent_id: 965346, response_d: true },
        { id: 969494, parent_id: 965347, response_a: true },
        { id: 969495, parent_id: 965348, response_d: true },
        { id: 969496, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 106,
        company_position_id: 519,
        tenure: 5,
        age: 39,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        {
          id: 969497,
          parent_id: 965308,
          respondant_comment: "",
          response_d: true,
        },
        { id: 969498, parent_id: 965309, response_c: true },
        { id: 969499, parent_id: 965310, response_d: true },
        { id: 969500, parent_id: 965311, response_b: true },
        { id: 969501, parent_id: 965312, response_d: true },
        { id: 969502, parent_id: 965313, response_c: true },
        { id: 969503, parent_id: 965314, response_c: true },
        { id: 969504, parent_id: 965315, response_d: true },
        { id: 969505, parent_id: 965316, response_d: true },
        { id: 969506, parent_id: 965317, response_e: true },
        { id: 969507, parent_id: 965318, response_d: true },
        { id: 969508, parent_id: 965319, response_e: true },
        { id: 969509, parent_id: 965320, response_d: true },
        { id: 969510, parent_id: 965321, response_d: true },
        { id: 969511, parent_id: 965322, response_d: true },
        { id: 969512, parent_id: 965323, response_b: true },
        { id: 969513, parent_id: 965324, response_d: true },
        { id: 969514, parent_id: 965325, response_c: true },
        { id: 969515, parent_id: 965326, response_e: true },
        { id: 969516, parent_id: 965327, response_e: true },
        { id: 969517, parent_id: 965328, response_d: true },
        { id: 969518, parent_id: 965329, response_d: true },
        { id: 969519, parent_id: 965330, response_c: true },
        { id: 969520, parent_id: 965331, response_c: true },
        { id: 969521, parent_id: 965332, response_d: true },
        { id: 969522, parent_id: 965333, response_e: true },
        { id: 969523, parent_id: 965334, response_e: true },
        { id: 969524, parent_id: 965335, response_d: true },
        { id: 969525, parent_id: 965336, response_d: true },
        { id: 969526, parent_id: 965337, response_c: true },
        { id: 969527, parent_id: 965338, response_c: true },
        { id: 969528, parent_id: 965339, response_c: true },
        { id: 969529, parent_id: 965340, response_c: true },
        { id: 969530, parent_id: 965341, response_d: true },
        { id: 969531, parent_id: 965342, response_c: true },
        { id: 969532, parent_id: 965343, response_c: true },
        { id: 969533, parent_id: 965344, response_d: true },
        { id: 969534, parent_id: 965345, response_d: true },
        { id: 969535, parent_id: 965346, response_c: true },
        { id: 969536, parent_id: 965347, response_d: true },
        { id: 969537, parent_id: 965348, response_d: true },
        { id: 969538, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 1,
        age: 48,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 969539, parent_id: 965308, response_c: true },
        { id: 969540, parent_id: 965309, response_c: true },
        { id: 969541, parent_id: 965310, response_c: true },
        { id: 969542, parent_id: 965311, response_c: true },
        { id: 969543, parent_id: 965312, response_c: true },
        { id: 969544, parent_id: 965313, response_d: true },
        { id: 969545, parent_id: 965314, response_d: true },
        { id: 969546, parent_id: 965315, response_c: true },
        { id: 969547, parent_id: 965316, response_d: true },
        { id: 969548, parent_id: 965317, response_b: true },
        { id: 969549, parent_id: 965318, response_c: true },
        { id: 969550, parent_id: 965319, response_b: true },
        { id: 969551, parent_id: 965320, response_c: true },
        { id: 969552, parent_id: 965321, response_b: true },
        { id: 969553, parent_id: 965322, response_b: true },
        { id: 969554, parent_id: 965323, response_c: true },
        { id: 969555, parent_id: 965324, response_b: true },
        { id: 969556, parent_id: 965325, response_c: true },
        { id: 969557, parent_id: 965326, response_d: true },
        { id: 969558, parent_id: 965327, response_c: true },
        { id: 969559, parent_id: 965328, response_c: true },
        { id: 969560, parent_id: 965329, response_b: true },
        { id: 969561, parent_id: 965330, response_a: true },
        { id: 969562, parent_id: 965331, response_b: true },
        { id: 969563, parent_id: 965332, response_b: true },
        { id: 969564, parent_id: 965333, response_c: true },
        { id: 969565, parent_id: 965334, response_c: true },
        { id: 969566, parent_id: 965335, response_a: true },
        { id: 969567, parent_id: 965336, response_b: true },
        { id: 969568, parent_id: 965337, response_a: true },
        { id: 969569, parent_id: 965338, response_c: true },
        { id: 969570, parent_id: 965339, response_b: true },
        { id: 969571, parent_id: 965340, response_c: true },
        { id: 969572, parent_id: 965341, response_b: true },
        { id: 969573, parent_id: 965342, response_b: true },
        { id: 969574, parent_id: 965343, response_d: true },
        { id: 969575, parent_id: 965344, response_c: true },
        { id: 969576, parent_id: 965345, response_b: true },
        { id: 969577, parent_id: 965346, response_b: true },
        { id: 969578, parent_id: 965347, response_d: true },
        { id: 969579, parent_id: 965348, response_c: true },
        { id: 969580, parent_id: 965349, response_c: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 106,
        company_position_id: 519,
        tenure: 3,
        age: 45,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 969581, parent_id: 965308, response_d: true },
        { id: 969582, parent_id: 965309, response_e: true },
        { id: 969583, parent_id: 965310, response_d: true },
        { id: 969584, parent_id: 965311, response_d: true },
        { id: 969585, parent_id: 965312, response_d: true },
        { id: 969586, parent_id: 965313, response_c: true },
        { id: 969587, parent_id: 965314, response_d: true },
        { id: 969588, parent_id: 965315, response_d: true },
        { id: 969589, parent_id: 965316, response_c: true },
        { id: 969590, parent_id: 965317, response_e: true },
        { id: 969591, parent_id: 965318, response_e: true },
        { id: 969592, parent_id: 965319, response_e: true },
        { id: 969593, parent_id: 965320, response_d: true },
        { id: 969594, parent_id: 965321, response_d: true },
        { id: 969595, parent_id: 965322, response_d: true },
        { id: 969596, parent_id: 965323, response_c: true },
        { id: 969597, parent_id: 965324, response_d: true },
        { id: 969598, parent_id: 965325, response_c: true },
        { id: 969599, parent_id: 965326, response_e: true },
        { id: 969600, parent_id: 965327, response_e: true },
        { id: 969601, parent_id: 965328, response_d: true },
        { id: 969602, parent_id: 965329, response_c: true },
        { id: 969603, parent_id: 965330, response_c: true },
        { id: 969604, parent_id: 965331, response_d: true },
        { id: 969605, parent_id: 965332, response_d: true },
        { id: 969606, parent_id: 965333, response_d: true },
        { id: 969607, parent_id: 965334, response_e: true },
        { id: 969608, parent_id: 965335, response_d: true },
        { id: 969609, parent_id: 965336, response_d: true },
        { id: 969610, parent_id: 965337, response_e: true },
        { id: 969611, parent_id: 965338, response_d: true },
        { id: 969612, parent_id: 965339, response_d: true },
        { id: 969613, parent_id: 965340, response_d: true },
        { id: 969614, parent_id: 965341, response_d: true },
        { id: 969615, parent_id: 965342, response_d: true },
        { id: 969616, parent_id: 965343, response_d: true },
        { id: 969617, parent_id: 965344, response_d: true },
        { id: 969618, parent_id: 965345, response_d: true },
        { id: 969619, parent_id: 965346, response_d: true },
        { id: 969620, parent_id: 965347, response_b: true },
        { id: 969621, parent_id: 965348, response_d: true },
        { id: 969622, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 106,
        company_position_id: 519,
        tenure: 2,
        age: 58,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 969623, parent_id: 965308, response_e: true },
        { id: 969624, parent_id: 965309, response_d: true },
        { id: 969625, parent_id: 965310, response_e: true },
        { id: 969626, parent_id: 965311, response_d: true },
        { id: 969627, parent_id: 965312, response_d: true },
        { id: 969628, parent_id: 965313, response_d: true },
        { id: 969629, parent_id: 965314, response_d: true },
        { id: 969630, parent_id: 965315, response_d: true },
        { id: 969631, parent_id: 965316, response_c: true },
        { id: 969632, parent_id: 965317, response_d: true },
        { id: 969633, parent_id: 965318, response_d: true },
        { id: 969634, parent_id: 965319, response_d: true },
        { id: 969635, parent_id: 965320, response_d: true },
        { id: 969636, parent_id: 965321, response_d: true },
        { id: 969637, parent_id: 965322, response_c: true },
        { id: 969638, parent_id: 965323, response_e: true },
        { id: 969639, parent_id: 965324, response_d: true },
        { id: 969640, parent_id: 965325, response_b: true },
        { id: 969641, parent_id: 965326, response_e: true },
        { id: 969642, parent_id: 965327, response_d: true },
        { id: 969643, parent_id: 965328, response_d: true },
        { id: 969644, parent_id: 965329, response_d: true },
        { id: 969645, parent_id: 965330, response_d: true },
        { id: 969646, parent_id: 965331, response_d: true },
        { id: 969647, parent_id: 965332, response_d: true },
        { id: 969648, parent_id: 965333, response_c: true },
        { id: 969649, parent_id: 965334, response_d: true },
        { id: 969650, parent_id: 965335, response_d: true },
        { id: 969651, parent_id: 965336, response_d: true },
        { id: 969652, parent_id: 965337, response_d: true },
        { id: 969653, parent_id: 965338, response_d: true },
        { id: 969654, parent_id: 965339, response_c: true },
        { id: 969655, parent_id: 965340, response_b: true },
        { id: 969656, parent_id: 965341, response_d: true },
        { id: 969657, parent_id: 965342, response_d: true },
        { id: 969658, parent_id: 965343, response_d: true },
        { id: 969659, parent_id: 965344, response_d: true },
        { id: 969660, parent_id: 965345, response_d: true },
        { id: 969661, parent_id: 965346, response_d: true },
        { id: 969662, parent_id: 965347, response_d: true },
        { id: 969663, parent_id: 965348, response_d: true },
        { id: 969664, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 106,
        company_position_id: 519,
        tenure: 4,
        age: 39,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 969665, parent_id: 965308, response_d: true },
        { id: 969666, parent_id: 965309, response_d: true },
        { id: 969667, parent_id: 965310, response_c: true },
        { id: 969668, parent_id: 965311, response_c: true },
        { id: 969669, parent_id: 965312, response_b: true },
        { id: 969670, parent_id: 965313, response_b: true },
        { id: 969671, parent_id: 965314, response_c: true },
        { id: 969672, parent_id: 965315, response_b: true },
        { id: 969673, parent_id: 965316, response_b: true },
        { id: 969674, parent_id: 965317, response_d: true },
        { id: 969675, parent_id: 965318, response_c: true },
        { id: 969676, parent_id: 965319, response_d: true },
        { id: 969677, parent_id: 965320, response_b: true },
        { id: 969678, parent_id: 965321, response_c: true },
        { id: 969679, parent_id: 965322, response_c: true },
        { id: 969680, parent_id: 965323, response_b: true },
        { id: 969681, parent_id: 965324, response_b: true },
        { id: 969682, parent_id: 965325, response_b: true },
        { id: 969683, parent_id: 965326, response_d: true },
        { id: 969684, parent_id: 965327, response_d: true },
        { id: 969685, parent_id: 965328, response_d: true },
        { id: 969686, parent_id: 965329, response_d: true },
        { id: 969687, parent_id: 965330, response_c: true },
        { id: 969688, parent_id: 965331, response_d: true },
        { id: 969689, parent_id: 965332, response_c: true },
        { id: 969690, parent_id: 965333, response_d: true },
        { id: 969691, parent_id: 965334, response_d: true },
        { id: 969692, parent_id: 965335, response_d: true },
        { id: 969693, parent_id: 965336, response_d: true },
        { id: 969694, parent_id: 965337, response_d: true },
        { id: 969695, parent_id: 965338, response_c: true },
        { id: 969696, parent_id: 965339, response_d: true },
        { id: 969697, parent_id: 965340, response_d: true },
        { id: 969698, parent_id: 965341, response_d: true },
        { id: 969699, parent_id: 965342, response_d: true },
        { id: 969700, parent_id: 965343, response_d: true },
        { id: 969701, parent_id: 965344, response_c: true },
        { id: 969702, parent_id: 965345, response_c: true },
        { id: 969703, parent_id: 965346, response_c: true },
        { id: 969704, parent_id: 965347, response_d: true },
        { id: 969705, parent_id: 965348, response_c: true },
        { id: 969706, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 108,
        company_position_id: 518,
        tenure: 2,
        age: 36,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 969707, parent_id: 965308, response_c: true },
        { id: 969708, parent_id: 965309, response_c: true },
        {
          id: 969709,
          parent_id: 965310,
          respondant_comment: "",
          response_c: true,
        },
        { id: 969710, parent_id: 965311, response_c: true },
        { id: 969711, parent_id: 965312, response_c: true },
        {
          id: 969712,
          parent_id: 965313,
          respondant_comment:
            "Some leaders yes, some leaders no. I believe we could all improve on that matter.",
          response_c: true,
        },
        { id: 969713, parent_id: 965314, response_c: true },
        {
          id: 969714,
          parent_id: 965315,
          respondant_comment:
            "It depends with whom you work. There are situations that you have to keep doing your job and keep thinking of things that your manager may forget and you have to remind him all the time.",
          response_c: true,
        },
        { id: 969715, parent_id: 965316, response_c: true },
        {
          id: 969716,
          parent_id: 965317,
          respondant_comment: "It depends with whom you work. ",
          response_c: true,
        },
        {
          id: 969717,
          parent_id: 965318,
          respondant_comment: "\n\n",
          response_c: true,
        },
        {
          id: 969718,
          parent_id: 965319,
          respondant_comment:
            "I would agree, there are some that you need to keep reminding stuff, but over all I think its good.",
          response_d: true,
        },
        { id: 969719, parent_id: 965320, response_c: true },
        {
          id: 969720,
          parent_id: 965321,
          respondant_comment: "It depends with whom you work. ",
          response_c: true,
        },
        { id: 969721, parent_id: 965322, response_c: true },
        { id: 969722, parent_id: 965323, response_d: true },
        { id: 969723, parent_id: 965324, response_d: true },
        { id: 969724, parent_id: 965325, response_c: true },
        { id: 969725, parent_id: 965326, response_d: true },
        { id: 969726, parent_id: 965327, response_d: true },
        { id: 969727, parent_id: 965328, response_d: true },
        { id: 969728, parent_id: 965329, response_d: true },
        { id: 969729, parent_id: 965330, response_e: true },
        { id: 969730, parent_id: 965331, response_c: true },
        {
          id: 969731,
          parent_id: 965332,
          respondant_comment: "It depends with whom you work.",
          response_c: true,
        },
        { id: 969732, parent_id: 965333, response_e: true },
        { id: 969733, parent_id: 965334, response_e: true },
        { id: 969734, parent_id: 965335, response_d: true },
        { id: 969735, parent_id: 965336, response_e: true },
        { id: 969736, parent_id: 965337, response_d: true },
        { id: 969737, parent_id: 965338, response_c: true },
        { id: 969738, parent_id: 965339, response_d: true },
        { id: 969739, parent_id: 965340, response_e: true },
        {
          id: 969740,
          parent_id: 965341,
          respondant_comment:
            "I think for this Job you have to have it on you and be able to think outside the box since its not just the training you get, there are many situation that you have to use your logic and what makes sense. ",
          response_c: true,
        },
        { id: 969741, parent_id: 965342, response_e: true },
        {
          id: 969742,
          parent_id: 965343,
          respondant_comment: "It depends with whom you work.",
          response_c: true,
        },
        { id: 969743, parent_id: 965344, response_d: true },
        { id: 969744, parent_id: 965345, response_c: true },
        { id: 969745, parent_id: 965346, response_d: true },
        { id: 969746, parent_id: 965347, response_d: true },
        { id: 969747, parent_id: 965348, response_d: true },
        { id: 969748, parent_id: 965349, response_e: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 108,
        company_position_id: 518,
        tenure: 2,
        age: 52,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 969749, parent_id: 965308, response_e: true },
        {
          id: 969750,
          parent_id: 965309,
          respondant_comment: "",
          response_e: true,
        },
        { id: 969751, parent_id: 965310, response_d: true },
        { id: 969752, parent_id: 965311, response_d: true },
        { id: 969753, parent_id: 965312, response_e: true },
        { id: 969754, parent_id: 965313, response_e: true },
        { id: 969755, parent_id: 965314, response_d: true },
        { id: 969756, parent_id: 965315, response_e: true },
        { id: 969757, parent_id: 965316, response_d: true },
        { id: 969758, parent_id: 965317, response_e: true },
        { id: 969759, parent_id: 965318, response_d: true },
        { id: 969760, parent_id: 965319, response_e: true },
        { id: 969761, parent_id: 965320, response_d: true },
        { id: 969762, parent_id: 965321, response_d: true },
        { id: 969763, parent_id: 965322, response_d: true },
        { id: 969764, parent_id: 965323, response_d: true },
        { id: 969765, parent_id: 965324, response_d: true },
        { id: 969766, parent_id: 965325, response_d: true },
        { id: 969767, parent_id: 965326, response_e: true },
        { id: 969768, parent_id: 965327, response_e: true },
        { id: 969769, parent_id: 965328, response_d: true },
        { id: 969770, parent_id: 965329, response_d: true },
        { id: 969771, parent_id: 965330, response_e: true },
        { id: 969772, parent_id: 965331, response_e: true },
        { id: 969773, parent_id: 965332, response_e: true },
        { id: 969774, parent_id: 965333, response_d: true },
        { id: 969775, parent_id: 965334, response_d: true },
        { id: 969776, parent_id: 965335, response_e: true },
        { id: 969777, parent_id: 965336, response_e: true },
        { id: 969778, parent_id: 965337, response_e: true },
        { id: 969779, parent_id: 965338, response_d: true },
        { id: 969780, parent_id: 965339, response_d: true },
        { id: 969781, parent_id: 965340, response_d: true },
        { id: 969782, parent_id: 965341, response_e: true },
        { id: 969783, parent_id: 965342, response_d: true },
        { id: 969784, parent_id: 965343, response_e: true },
        { id: 969785, parent_id: 965344, response_d: true },
        { id: 969786, parent_id: 965345, response_e: true },
        { id: 969787, parent_id: 965346, response_e: true },
        { id: 969788, parent_id: 965347, response_d: true },
        { id: 969789, parent_id: 965348, response_d: true },
        { id: 969790, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 108,
        company_position_id: 518,
        tenure: 3,
        age: 44,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 969791, parent_id: 965308, response_d: true },
        { id: 969792, parent_id: 965309, response_c: true },
        { id: 969793, parent_id: 965310, response_c: true },
        {
          id: 969794,
          parent_id: 965311,
          respondant_comment: "",
          response_c: true,
        },
        { id: 969795, parent_id: 965312, response_d: true },
        { id: 969796, parent_id: 965313, response_c: true },
        { id: 969797, parent_id: 965314, response_c: true },
        { id: 969798, parent_id: 965315, response_d: true },
        { id: 969799, parent_id: 965316, response_c: true },
        { id: 969800, parent_id: 965317, response_e: true },
        { id: 969801, parent_id: 965318, response_d: true },
        { id: 969802, parent_id: 965319, response_e: true },
        { id: 969803, parent_id: 965320, response_d: true },
        { id: 969804, parent_id: 965321, response_d: true },
        { id: 969805, parent_id: 965322, response_d: true },
        { id: 969806, parent_id: 965323, response_b: true },
        { id: 969807, parent_id: 965324, response_c: true },
        { id: 969808, parent_id: 965325, response_c: true },
        { id: 969809, parent_id: 965326, response_e: true },
        { id: 969810, parent_id: 965327, response_d: true },
        { id: 969811, parent_id: 965328, response_d: true },
        { id: 969812, parent_id: 965329, response_d: true },
        { id: 969813, parent_id: 965330, response_c: true },
        { id: 969814, parent_id: 965331, response_c: true },
        { id: 969815, parent_id: 965332, response_c: true },
        { id: 969816, parent_id: 965333, response_e: true },
        { id: 969817, parent_id: 965334, response_e: true },
        { id: 969818, parent_id: 965335, response_d: true },
        { id: 969819, parent_id: 965336, response_c: true },
        { id: 969820, parent_id: 965337, response_c: true },
        { id: 969821, parent_id: 965338, response_c: true },
        { id: 969822, parent_id: 965339, response_c: true },
        { id: 969823, parent_id: 965340, response_c: true },
        { id: 969824, parent_id: 965341, response_d: true },
        { id: 969825, parent_id: 965342, response_c: true },
        { id: 969826, parent_id: 965343, response_c: true },
        { id: 969827, parent_id: 965344, response_d: true },
        { id: 969828, parent_id: 965345, response_d: true },
        { id: 969829, parent_id: 965346, response_c: true },
        { id: 969830, parent_id: 965347, response_d: true },
        { id: 969831, parent_id: 965348, response_d: true },
        { id: 969832, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 1,
        age: 35,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 969833, parent_id: 965308, response_d: true },
        { id: 969834, parent_id: 965309, response_c: true },
        { id: 969835, parent_id: 965310, response_d: true },
        { id: 969836, parent_id: 965311, response_b: true },
        { id: 969837, parent_id: 965312, response_c: true },
        { id: 969838, parent_id: 965313, response_c: true },
        { id: 969839, parent_id: 965314, response_d: true },
        { id: 969840, parent_id: 965315, response_c: true },
        { id: 969841, parent_id: 965316, response_c: true },
        { id: 969842, parent_id: 965317, response_d: true },
        { id: 969843, parent_id: 965318, response_d: true },
        { id: 969844, parent_id: 965319, response_d: true },
        { id: 969845, parent_id: 965320, response_c: true },
        { id: 969846, parent_id: 965321, response_c: true },
        { id: 969847, parent_id: 965322, response_c: true },
        { id: 969848, parent_id: 965323, response_c: true },
        { id: 969849, parent_id: 965324, response_c: true },
        { id: 969850, parent_id: 965325, response_c: true },
        { id: 969851, parent_id: 965326, response_d: true },
        { id: 969852, parent_id: 965327, response_d: true },
        { id: 969853, parent_id: 965328, response_d: true },
        { id: 969854, parent_id: 965329, response_c: true },
        { id: 969855, parent_id: 965330, response_c: true },
        { id: 969856, parent_id: 965331, response_c: true },
        { id: 969857, parent_id: 965332, response_c: true },
        { id: 969858, parent_id: 965333, response_d: true },
        { id: 969859, parent_id: 965334, response_d: true },
        { id: 969860, parent_id: 965335, response_d: true },
        { id: 969861, parent_id: 965336, response_d: true },
        { id: 969862, parent_id: 965337, response_c: true },
        { id: 969863, parent_id: 965338, response_c: true },
        { id: 969864, parent_id: 965339, response_c: true },
        { id: 969865, parent_id: 965340, response_d: true },
        { id: 969866, parent_id: 965341, response_d: true },
        { id: 969867, parent_id: 965342, response_d: true },
        { id: 969868, parent_id: 965343, response_d: true },
        { id: 969869, parent_id: 965344, response_d: true },
        { id: 969870, parent_id: 965345, response_d: true },
        { id: 969871, parent_id: 965346, response_d: true },
        { id: 969872, parent_id: 965347, response_d: true },
        { id: 969873, parent_id: 965348, response_d: true },
        { id: 969874, parent_id: 965349, response_c: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 109,
        company_position_id: 521,
        tenure: 1,
        age: 40,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        {
          id: 969875,
          parent_id: 965308,
          respondant_comment: "",
          response_d: true,
        },
        {
          id: 969876,
          parent_id: 965309,
          respondant_comment:
            "I do trust the team and the organization, No one is out to get you, the opposite everyone is helpful and ready to help whenever you need assistance with anything.",
          response_d: true,
        },
        {
          id: 969877,
          parent_id: 965310,
          respondant_comment:
            "Absolutely committed to everyone in the organization.",
          response_e: true,
        },
        {
          id: 969878,
          parent_id: 965311,
          respondant_comment:
            "Some of the employees can perform more than they are per my opinion. The potential is there and they have the tools. I believe realistic expectations are set and are clear by the organization and the project, but more can be done always as far as delivering quality and speed to the projects.",
          response_c: true,
        },
        { id: 969879, parent_id: 965312, response_d: true },
        {
          id: 969880,
          parent_id: 965313,
          respondant_comment:
            "We are like family and the fact that we enjoy each other's company in every gathering tells you that this brings out the best in us.",
          response_e: true,
        },
        { id: 969881, parent_id: 965314, response_d: true },
        {
          id: 969882,
          parent_id: 965315,
          respondant_comment:
            "I missed a comment one question prior. Regular feedback is provided and praised by the upper management to most of us, weather is one on one or in the group team call. However going back one quesiton i think the model of having one AE, one Recruiter and one Sources bring the healthy competition down. Having to work with multiple people in a project brings the best out of you. I saw this as a healthy competition model. ",
          response_e: true,
        },
        { id: 969883, parent_id: 965316, response_c: true },
        {
          id: 969884,
          parent_id: 965317,
          respondant_comment:
            "Always on team chats and team scall with the team to be 100% up te speed on all the projects.",
          response_e: true,
        },
        { id: 969885, parent_id: 965318, response_e: true },
        { id: 969886, parent_id: 965319, response_e: true },
        {
          id: 969887,
          parent_id: 965320,
          respondant_comment: "most of the time yes. ",
          response_d: true,
        },
        { id: 969888, parent_id: 965321, response_e: true },
        { id: 969889, parent_id: 965322, response_e: true },
        { id: 969890, parent_id: 965323, response_e: true },
        { id: 969891, parent_id: 965324, response_e: true },
        { id: 969892, parent_id: 965325, response_d: true },
        {
          id: 969893,
          parent_id: 965326,
          respondant_comment:
            "The old ways of collaborating with different AE, recruiter and sources was a bit too much at times jumping from one project to another with different people but now having to deal with only your team members gets boring at times dealing with same team members. Basically, makes you feel like you are out of PTS because there is no more collaboration with other team members except get togethers out in the city.",
          response_c: true,
        },
        { id: 969894, parent_id: 965327, response_e: true },
        { id: 969895, parent_id: 965328, response_d: true },
        {
          id: 969896,
          parent_id: 965329,
          respondant_comment:
            "As long as i perform and do my job. No one is and should be secured. This is solely based on performance. ",
          response_c: true,
        },
        { id: 969897, parent_id: 965330, response_e: true },
        {
          id: 969898,
          parent_id: 965331,
          respondant_comment:
            "We are free to share our opinions but most of the time the ideas and options are only heard and never implemented or even tried. I believe management should listen more to the folks on the ground starting from the sourcer all the way to the AE on processes that are more efficient and makes our job easier.",
          response_d: true,
        },
        { id: 969899, parent_id: 965332, response_e: true },
        { id: 969900, parent_id: 965333, response_d: true },
        { id: 969901, parent_id: 965334, response_d: true },
        {
          id: 969902,
          parent_id: 965335,
          respondant_comment:
            "At times yes, but not all the time. I believe at times everyone is overloaded with project and are trying to deliver the best candidate to the client that sometimes we lose focus on the new incoming folks and give them the proper guidance not just in the first two months' probation period but for several months until they are brough up to speed and are comfortable on their own. ",
          response_c: true,
        },
        {
          id: 969903,
          parent_id: 965336,
          respondant_comment:
            "Agree but most of the processes need to be simplified and better connected with each other. We are jumping from one new process to another without mastering the first one. Simply put none of the processes we have don't link up to one process which was supposed to be BH. Each process is on its own and they take unnecessary time to complete a candidate's package. Our ultimate goal is to provide the best candidate to our client, however sometimes I feel like we overloaded out self and the team with all these different processes.",
          response_d: true,
        },
        { id: 969904, parent_id: 965337, response_c: true },
        { id: 969905, parent_id: 965338, response_c: true },
        {
          id: 969906,
          parent_id: 965339,
          respondant_comment: "",
          response_c: true,
        },
        { id: 969907, parent_id: 965340, response_c: true },
        { id: 969908, parent_id: 965341, response_d: true },
        { id: 969909, parent_id: 965342, response_d: true },
        { id: 969910, parent_id: 965343, response_c: true },
        {
          id: 969911,
          parent_id: 965344,
          respondant_comment:
            "We can do better. Since the teams were created i believe we know very little about other project and other team members issues and difficulties. Monday's and Thursday's project meeting are too formal and do not represent the overall depth of the projects. On other words if you are not part of that project, you have very little knowledge of other projects.",
          response_c: true,
        },
        { id: 969912, parent_id: 965345, response_e: true },
        { id: 969913, parent_id: 965346, response_d: true },
        {
          id: 969914,
          parent_id: 965347,
          respondant_comment:
            "Most of the time no. We need more staff to be able to close more project and bring the turnaround on the project less then 70 days. ",
          response_d: true,
        },
        { id: 969915, parent_id: 965348, response_d: true },
        {
          id: 969916,
          parent_id: 965349,
          respondant_comment: "test",
          response_d: true,
        },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 109,
        company_position_id: 521,
        tenure: 1,
        age: 39,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 969917, parent_id: 965308, response_e: true },
        { id: 969918, parent_id: 965309, response_e: true },
        { id: 969919, parent_id: 965310, response_e: true },
        { id: 969920, parent_id: 965311, response_e: true },
        { id: 969921, parent_id: 965312, response_d: true },
        { id: 969922, parent_id: 965313, response_d: true },
        { id: 969923, parent_id: 965314, response_d: true },
        { id: 969924, parent_id: 965315, response_d: true },
        { id: 969925, parent_id: 965316, response_e: true },
        { id: 969926, parent_id: 965317, response_d: true },
        { id: 969927, parent_id: 965318, response_d: true },
        { id: 969928, parent_id: 965319, response_e: true },
        { id: 969929, parent_id: 965320, response_d: true },
        { id: 969930, parent_id: 965321, response_d: true },
        { id: 969931, parent_id: 965322, response_d: true },
        { id: 969932, parent_id: 965323, response_e: true },
        { id: 969933, parent_id: 965324, response_e: true },
        { id: 969934, parent_id: 965325, response_d: true },
        { id: 969935, parent_id: 965326, response_e: true },
        { id: 969936, parent_id: 965327, response_e: true },
        { id: 969937, parent_id: 965328, response_e: true },
        { id: 969938, parent_id: 965329, response_e: true },
        { id: 969939, parent_id: 965330, response_e: true },
        { id: 969940, parent_id: 965331, response_e: true },
        { id: 969941, parent_id: 965332, response_e: true },
        { id: 969942, parent_id: 965333, response_e: true },
        { id: 969943, parent_id: 965334, response_e: true },
        { id: 969944, parent_id: 965335, response_e: true },
        { id: 969945, parent_id: 965336, response_e: true },
        { id: 969946, parent_id: 965337, response_e: true },
        { id: 969947, parent_id: 965338, response_d: true },
        { id: 969948, parent_id: 965339, response_d: true },
        { id: 969949, parent_id: 965340, response_e: true },
        { id: 969950, parent_id: 965341, response_e: true },
        { id: 969951, parent_id: 965342, response_e: true },
        { id: 969952, parent_id: 965343, response_e: true },
        { id: 969953, parent_id: 965344, response_e: true },
        { id: 969954, parent_id: 965345, response_d: true },
        { id: 969955, parent_id: 965346, response_d: true },
        { id: 969956, parent_id: 965347, response_d: true },
        { id: 969957, parent_id: 965348, response_d: true },
        { id: 969958, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 108,
        company_position_id: 518,
        tenure: 3,
        age: 43,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        {
          id: 969959,
          parent_id: 965308,
          respondant_comment: "",
          response_d: true,
        },
        { id: 969960, parent_id: 965309, response_e: true },
        { id: 969961, parent_id: 965310, response_e: true },
        { id: 969962, parent_id: 965311, response_d: true },
        { id: 969963, parent_id: 965312, response_c: true },
        { id: 969964, parent_id: 965313, response_d: true },
        { id: 969965, parent_id: 965314, response_d: true },
        { id: 969966, parent_id: 965315, response_c: true },
        { id: 969967, parent_id: 965316, response_d: true },
        { id: 969968, parent_id: 965317, response_d: true },
        { id: 969969, parent_id: 965318, response_c: true },
        { id: 969970, parent_id: 965319, response_e: true },
        { id: 969971, parent_id: 965320, response_d: true },
        { id: 969972, parent_id: 965321, response_d: true },
        { id: 969973, parent_id: 965322, response_d: true },
        { id: 969974, parent_id: 965323, response_d: true },
        { id: 969975, parent_id: 965324, response_c: true },
        { id: 969976, parent_id: 965325, response_d: true },
        { id: 969977, parent_id: 965326, response_d: true },
        { id: 969978, parent_id: 965327, response_d: true },
        { id: 969979, parent_id: 965328, response_d: true },
        { id: 969980, parent_id: 965329, response_e: true },
        { id: 969981, parent_id: 965330, response_d: true },
        { id: 969982, parent_id: 965331, response_e: true },
        { id: 969983, parent_id: 965332, response_d: true },
        { id: 969984, parent_id: 965333, response_e: true },
        { id: 969985, parent_id: 965334, response_e: true },
        { id: 969986, parent_id: 965335, response_e: true },
        { id: 969987, parent_id: 965336, response_e: true },
        { id: 969988, parent_id: 965337, response_e: true },
        { id: 969989, parent_id: 965338, response_d: true },
        { id: 969990, parent_id: 965339, response_d: true },
        { id: 969991, parent_id: 965340, response_e: true },
        { id: 969992, parent_id: 965341, response_e: true },
        { id: 969993, parent_id: 965342, response_e: true },
        { id: 969994, parent_id: 965343, response_e: true },
        { id: 969995, parent_id: 965344, response_e: true },
        { id: 969996, parent_id: 965345, response_d: true },
        { id: 969997, parent_id: 965346, response_d: true },
        { id: 969998, parent_id: 965347, response_d: true },
        { id: 969999, parent_id: 965348, response_e: true },
        { id: 970000, parent_id: 965349, response_e: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 2,
        age: 39,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 970001, parent_id: 965308, response_e: true },
        { id: 970002, parent_id: 965309, response_d: true },
        { id: 970003, parent_id: 965310, response_d: true },
        { id: 970004, parent_id: 965311, response_c: true },
        { id: 970005, parent_id: 965312, response_d: true },
        { id: 970006, parent_id: 965313, response_d: true },
        { id: 970007, parent_id: 965314, response_d: true },
        { id: 970008, parent_id: 965315, response_d: true },
        { id: 970009, parent_id: 965316, response_d: true },
        { id: 970010, parent_id: 965317, response_e: true },
        { id: 970011, parent_id: 965318, response_e: true },
        { id: 970012, parent_id: 965319, response_d: true },
        { id: 970013, parent_id: 965320, response_d: true },
        { id: 970014, parent_id: 965321, response_e: true },
        { id: 970015, parent_id: 965322, response_e: true },
        { id: 970016, parent_id: 965323, response_c: true },
        { id: 970017, parent_id: 965324, response_d: true },
        { id: 970018, parent_id: 965325, response_d: true },
        { id: 970019, parent_id: 965326, response_d: true },
        { id: 970020, parent_id: 965327, response_d: true },
        { id: 970021, parent_id: 965328, response_d: true },
        { id: 970022, parent_id: 965329, response_d: true },
        { id: 970023, parent_id: 965330, response_d: true },
        { id: 970024, parent_id: 965331, response_d: true },
        { id: 970025, parent_id: 965332, response_d: true },
        { id: 970026, parent_id: 965333, response_d: true },
        { id: 970027, parent_id: 965334, response_d: true },
        { id: 970028, parent_id: 965335, response_c: true },
        { id: 970029, parent_id: 965336, response_c: true },
        { id: 970030, parent_id: 965337, response_d: true },
        { id: 970031, parent_id: 965338, response_d: true },
        { id: 970032, parent_id: 965339, response_d: true },
        { id: 970033, parent_id: 965340, response_d: true },
        { id: 970034, parent_id: 965341, response_c: true },
        { id: 970035, parent_id: 965342, response_d: true },
        { id: 970036, parent_id: 965343, response_d: true },
        { id: 970037, parent_id: 965344, response_d: true },
        { id: 970038, parent_id: 965345, response_e: true },
        { id: 970039, parent_id: 965346, response_d: true },
        { id: 970040, parent_id: 965347, response_d: true },
        { id: 970041, parent_id: 965348, response_d: true },
        { id: 970042, parent_id: 965349, response_c: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 108,
        company_position_id: 518,
        tenure: 3,
        age: 39,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 970043, parent_id: 965308, response_e: true },
        { id: 970044, parent_id: 965309, response_e: true },
        {
          id: 970045,
          parent_id: 965310,
          respondant_comment: " ",
          response_d: true,
        },
        { id: 970046, parent_id: 965311, response_d: true },
        { id: 970047, parent_id: 965312, response_e: true },
        { id: 970048, parent_id: 965313, response_e: true },
        {
          id: 970049,
          parent_id: 965314,
          respondant_comment: "",
          response_b: true,
        },
        { id: 970050, parent_id: 965315, response_d: true },
        { id: 970051, parent_id: 965316, response_d: true },
        { id: 970052, parent_id: 965317, response_d: true },
        { id: 970053, parent_id: 965318, response_d: true },
        {
          id: 970054,
          parent_id: 965319,
          respondant_comment: "",
          response_e: true,
        },
        {
          id: 970055,
          parent_id: 965320,
          respondant_comment: "",
          response_e: true,
        },
        { id: 970056, parent_id: 965321, response_e: true },
        {
          id: 970057,
          parent_id: 965322,
          respondant_comment: "",
          response_e: true,
        },
        {
          id: 970058,
          parent_id: 965323,
          respondant_comment: "There is room for improvement. ",
          response_d: true,
        },
        { id: 970059, parent_id: 965324, response_d: true },
        { id: 970060, parent_id: 965325, response_d: true },
        {
          id: 970061,
          parent_id: 965326,
          respondant_comment: "",
          response_e: true,
        },
        { id: 970062, parent_id: 965327, response_e: true },
        { id: 970063, parent_id: 965328, response_e: true },
        {
          id: 970064,
          parent_id: 965329,
          respondant_comment: "",
          response_c: true,
        },
        { id: 970065, parent_id: 965330, response_e: true },
        { id: 970066, parent_id: 965331, response_e: true },
        { id: 970067, parent_id: 965332, response_d: true },
        { id: 970068, parent_id: 965333, response_c: true },
        { id: 970069, parent_id: 965334, response_e: true },
        { id: 970070, parent_id: 965335, response_d: true },
        { id: 970071, parent_id: 965336, response_d: true },
        {
          id: 970072,
          parent_id: 965337,
          respondant_comment: "",
          response_c: true,
        },
        {
          id: 970073,
          parent_id: 965338,
          respondant_comment: "",
          response_c: true,
        },
        { id: 970074, parent_id: 965339, response_d: true },
        { id: 970075, parent_id: 965340, response_d: true },
        { id: 970076, parent_id: 965341, response_d: true },
        { id: 970077, parent_id: 965342, response_d: true },
        { id: 970078, parent_id: 965343, response_d: true },
        {
          id: 970079,
          parent_id: 965344,
          respondant_comment: "Depends on the decisions.",
          response_b: true,
        },
        {
          id: 970080,
          parent_id: 965345,
          respondant_comment: "",
          response_d: true,
        },
        { id: 970081, parent_id: 965346, response_d: true },
        { id: 970082, parent_id: 965347, response_d: true },
        {
          id: 970083,
          parent_id: 965348,
          respondant_comment:
            "PTS has a great understanding of workload. There is always help from the team when needed.",
          response_d: true,
        },
        {
          id: 970084,
          parent_id: 965349,
          respondant_comment: "",
          response_c: true,
        },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 109,
        company_position_id: 521,
        tenure: 1,
        age: 46,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 970085, parent_id: 965308, response_d: true },
        { id: 970086, parent_id: 965309, response_d: true },
        { id: 970087, parent_id: 965310, response_e: true },
        { id: 970088, parent_id: 965311, response_d: true },
        { id: 970089, parent_id: 965312, response_d: true },
        { id: 970090, parent_id: 965313, response_d: true },
        { id: 970091, parent_id: 965314, response_c: true },
        { id: 970092, parent_id: 965315, response_e: true },
        { id: 970093, parent_id: 965316, response_c: true },
        { id: 970094, parent_id: 965317, response_d: true },
        { id: 970095, parent_id: 965318, response_e: true },
        { id: 970096, parent_id: 965319, response_d: true },
        { id: 970097, parent_id: 965320, response_d: true },
        { id: 970098, parent_id: 965321, response_e: true },
        { id: 970099, parent_id: 965322, response_e: true },
        { id: 970100, parent_id: 965323, response_c: true },
        { id: 970101, parent_id: 965324, response_d: true },
        { id: 970102, parent_id: 965325, response_e: true },
        { id: 970103, parent_id: 965326, response_e: true },
        { id: 970104, parent_id: 965327, response_d: true },
        { id: 970105, parent_id: 965328, response_d: true },
        { id: 970106, parent_id: 965329, response_c: true },
        { id: 970107, parent_id: 965330, response_d: true },
        { id: 970108, parent_id: 965331, response_d: true },
        { id: 970109, parent_id: 965332, response_d: true },
        { id: 970110, parent_id: 965333, response_d: true },
        { id: 970111, parent_id: 965334, response_c: true },
        { id: 970112, parent_id: 965335, response_c: true },
        { id: 970113, parent_id: 965336, response_c: true },
        { id: 970114, parent_id: 965337, response_d: true },
        { id: 970115, parent_id: 965338, response_e: true },
        { id: 970116, parent_id: 965339, response_d: true },
        { id: 970117, parent_id: 965340, response_c: true },
        { id: 970118, parent_id: 965341, response_c: true },
        { id: 970119, parent_id: 965342, response_d: true },
        { id: 970120, parent_id: 965343, response_d: true },
        { id: 970121, parent_id: 965344, response_c: true },
        { id: 970122, parent_id: 965345, response_d: true },
        { id: 970123, parent_id: 965346, response_c: true },
        { id: 970124, parent_id: 965347, response_c: true },
        { id: 970125, parent_id: 965348, response_d: true },
        { id: 970126, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 1,
        age: 20,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 970169, parent_id: 965308, response_e: true },
        { id: 970170, parent_id: 965309, response_e: true },
        { id: 970171, parent_id: 965310, response_e: true },
        { id: 970172, parent_id: 965311, response_d: true },
        {
          id: 970173,
          parent_id: 965312,
          respondant_comment:
            "Support upon asking for it, not by checking in or by default.",
          response_d: true,
        },
        { id: 970174, parent_id: 965313, response_e: true },
        { id: 970175, parent_id: 965314, response_e: true },
        {
          id: 970176,
          parent_id: 965315,
          respondant_comment:
            "I only get feedback on specific activities and tasks not on my performance as a whole. ",
          response_b: true,
        },
        { id: 970177, parent_id: 965316, response_d: true },
        { id: 970178, parent_id: 965317, response_c: true },
        { id: 970179, parent_id: 965318, response_e: true },
        { id: 970180, parent_id: 965319, response_e: true },
        { id: 970181, parent_id: 965320, response_a: true },
        { id: 970182, parent_id: 965321, response_d: true },
        { id: 970183, parent_id: 965322, response_e: true },
        { id: 970184, parent_id: 965323, response_e: true },
        { id: 970185, parent_id: 965324, response_c: true },
        { id: 970186, parent_id: 965325, response_d: true },
        { id: 970187, parent_id: 965326, response_e: true },
        { id: 970188, parent_id: 965327, response_e: true },
        { id: 970189, parent_id: 965328, response_d: true },
        { id: 970190, parent_id: 965329, response_d: true },
        { id: 970191, parent_id: 965330, response_d: true },
        { id: 970192, parent_id: 965331, response_d: true },
        { id: 970193, parent_id: 965332, response_d: true },
        { id: 970194, parent_id: 965333, response_c: true },
        { id: 970195, parent_id: 965334, response_d: true },
        {
          id: 970196,
          parent_id: 965335,
          respondant_comment:
            "I wish we had a dedicated yearly budget for personal development activities - it would make it easier to determine whether or not we can request to attend a course or whether it is outside the budget scope for example. ",
          response_c: true,
        },
        { id: 970197, parent_id: 965336, response_c: true },
        { id: 970198, parent_id: 965337, response_c: true },
        { id: 970199, parent_id: 965338, response_a: true },
        { id: 970200, parent_id: 965339, response_a: true },
        { id: 970201, parent_id: 965340, response_d: true },
        { id: 970202, parent_id: 965341, response_b: true },
        { id: 970203, parent_id: 965342, response_c: true },
        { id: 970204, parent_id: 965343, response_c: true },
        { id: 970205, parent_id: 965344, response_d: true },
        { id: 970206, parent_id: 965345, response_b: true },
        { id: 970207, parent_id: 965346, response_d: true },
        { id: 970208, parent_id: 965347, response_d: true },
        { id: 970209, parent_id: 965348, response_d: true },
        { id: 970210, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 107,
        company_position_id: 520,
        tenure: 0,
        age: 22,
        salary_in_pennies: 0,
        gender: 2,
      },
      responses: [
        { id: 970211, parent_id: 965308, response_d: true },
        { id: 970212, parent_id: 965309, response_e: true },
        { id: 970213, parent_id: 965310, response_e: true },
        { id: 970214, parent_id: 965311, response_e: true },
        { id: 970215, parent_id: 965312, response_d: true },
        { id: 970216, parent_id: 965313, response_d: true },
        { id: 970217, parent_id: 965314, response_d: true },
        { id: 970218, parent_id: 965315, response_d: true },
        { id: 970219, parent_id: 965316, response_d: true },
        { id: 970220, parent_id: 965317, response_e: true },
        { id: 970221, parent_id: 965318, response_d: true },
        { id: 970222, parent_id: 965319, response_e: true },
        { id: 970223, parent_id: 965320, response_c: true },
        { id: 970224, parent_id: 965321, response_d: true },
        { id: 970225, parent_id: 965322, response_d: true },
        { id: 970226, parent_id: 965323, response_d: true },
        { id: 970227, parent_id: 965324, response_d: true },
        { id: 970228, parent_id: 965325, response_d: true },
        { id: 970229, parent_id: 965326, response_d: true },
        { id: 970230, parent_id: 965327, response_e: true },
        { id: 970231, parent_id: 965328, response_d: true },
        { id: 970232, parent_id: 965329, response_d: true },
        { id: 970233, parent_id: 965330, response_d: true },
        { id: 970234, parent_id: 965331, response_d: true },
        { id: 970235, parent_id: 965332, response_d: true },
        { id: 970236, parent_id: 965333, response_d: true },
        { id: 970237, parent_id: 965334, response_d: true },
        { id: 970238, parent_id: 965335, response_c: true },
        { id: 970239, parent_id: 965336, response_d: true },
        { id: 970240, parent_id: 965337, response_d: true },
        { id: 970241, parent_id: 965338, response_d: true },
        { id: 970242, parent_id: 965339, response_d: true },
        { id: 970243, parent_id: 965340, response_d: true },
        { id: 970244, parent_id: 965341, response_d: true },
        { id: 970245, parent_id: 965342, response_c: true },
        { id: 970246, parent_id: 965343, response_d: true },
        { id: 970247, parent_id: 965344, response_d: true },
        { id: 970248, parent_id: 965345, response_d: true },
        { id: 970249, parent_id: 965346, response_d: true },
        { id: 970250, parent_id: 965347, response_d: true },
        { id: 970251, parent_id: 965348, response_d: true },
        { id: 970252, parent_id: 965349, response_e: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 109,
        company_position_id: 521,
        tenure: 0,
        age: 47,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        { id: 970253, parent_id: 965308, response_e: true },
        {
          id: 970254,
          parent_id: 965309,
          respondant_comment: "",
          response_d: true,
        },
        { id: 970255, parent_id: 965310, response_d: true },
        { id: 970256, parent_id: 965311, response_d: true },
        { id: 970257, parent_id: 965312, response_e: true },
        { id: 970258, parent_id: 965313, response_e: true },
        { id: 970259, parent_id: 965314, response_d: true },
        { id: 970260, parent_id: 965315, response_d: true },
        { id: 970261, parent_id: 965316, response_d: true },
        { id: 970262, parent_id: 965317, response_e: true },
        { id: 970263, parent_id: 965318, response_d: true },
        { id: 970264, parent_id: 965319, response_e: true },
        { id: 970265, parent_id: 965320, response_d: true },
        { id: 970266, parent_id: 965321, response_d: true },
        { id: 970267, parent_id: 965322, response_d: true },
        { id: 970268, parent_id: 965323, response_d: true },
        { id: 970269, parent_id: 965324, response_d: true },
        { id: 970270, parent_id: 965325, response_c: true },
        { id: 970271, parent_id: 965326, response_e: true },
        { id: 970272, parent_id: 965327, response_e: true },
        { id: 970273, parent_id: 965328, response_e: true },
        { id: 970274, parent_id: 965329, response_d: true },
        { id: 970275, parent_id: 965330, response_d: true },
        { id: 970276, parent_id: 965331, response_e: true },
        { id: 970277, parent_id: 965332, response_d: true },
        { id: 970278, parent_id: 965333, response_d: true },
        { id: 970279, parent_id: 965334, response_d: true },
        { id: 970280, parent_id: 965335, response_e: true },
        { id: 970281, parent_id: 965336, response_e: true },
        { id: 970282, parent_id: 965337, response_d: true },
        { id: 970283, parent_id: 965338, response_d: true },
        { id: 970284, parent_id: 965339, response_c: true },
        { id: 970285, parent_id: 965340, response_d: true },
        { id: 970286, parent_id: 965341, response_d: true },
        { id: 970287, parent_id: 965342, response_d: true },
        { id: 970288, parent_id: 965343, response_c: true },
        { id: 970289, parent_id: 965344, response_e: true },
        { id: 970290, parent_id: 965345, response_d: true },
        { id: 970291, parent_id: 965346, response_d: true },
        { id: 970292, parent_id: 965347, response_d: true },
        { id: 970293, parent_id: 965348, response_d: true },
        { id: 970294, parent_id: 965349, response_d: true },
      ],
    },
    {
      data: {
        race: 1,
        ethnicity: 0,
        department_id: 109,
        company_position_id: 521,
        tenure: 0,
        age: 43,
        salary_in_pennies: 0,
        gender: 1,
      },
      responses: [
        {
          id: 970295,
          parent_id: 965308,
          respondant_comment: "",
          response_d: true,
        },
        { id: 970296, parent_id: 965309, response_d: true },
        { id: 970297, parent_id: 965310, response_e: true },
        { id: 970298, parent_id: 965311, response_d: true },
        { id: 970299, parent_id: 965312, response_c: true },
        { id: 970300, parent_id: 965313, response_d: true },
        {
          id: 970301,
          parent_id: 965314,
          respondant_comment:
            "People's skills deserve more recognition and appreciation, as it can boost their motivation and pride in their abilities.",
          response_d: true,
        },
        { id: 970302, parent_id: 965315, response_d: true },
        { id: 970303, parent_id: 965316, response_c: true },
        {
          id: 970304,
          parent_id: 965317,
          respondant_comment:
            "One way to improve the process is to foster a positive work environment that celebrates teamwork and encourages open communication. This can be achieved by recognizing and rewarding team accomplishments, providing opportunities for team building activities, and promoting a culture of inclusivity and respect. ",
          response_d: true,
        },
        {
          id: 970305,
          parent_id: 965318,
          respondant_comment:
            "In order to improve the process, it is important for supervisors to build trust with their team members by actively listening to their ideas and taking their feedback into consideration.",
          response_d: true,
        },
        { id: 970306, parent_id: 965319, response_e: true },
        { id: 970307, parent_id: 965320, response_d: true },
        {
          id: 970308,
          parent_id: 965321,
          respondant_comment:
            "To improve the process, it is important for managers to create a culture of open communication and actively seek out feedback from team members. This can help to build trust and respect, and ensure that everyone's ideas are taken into consideration",
          response_c: true,
        },
        { id: 970309, parent_id: 965322, response_b: true },
        { id: 970310, parent_id: 965323, response_d: true },
        { id: 970311, parent_id: 965324, response_c: true },
        { id: 970312, parent_id: 965325, response_c: true },
        { id: 970313, parent_id: 965326, response_d: true },
        { id: 970314, parent_id: 965327, response_d: true },
        { id: 970315, parent_id: 965328, response_c: true },
        { id: 970316, parent_id: 965329, response_c: true },
        { id: 970317, parent_id: 965330, response_c: true },
        { id: 970318, parent_id: 965331, response_b: true },
        { id: 970319, parent_id: 965332, response_d: true },
        { id: 970320, parent_id: 965333, response_d: true },
        { id: 970321, parent_id: 965334, response_e: true },
        { id: 970322, parent_id: 965335, response_d: true },
        { id: 970323, parent_id: 965336, response_d: true },
        { id: 970324, parent_id: 965337, response_c: true },
        { id: 970325, parent_id: 965338, response_c: true },
        { id: 970326, parent_id: 965339, response_b: true },
        { id: 970327, parent_id: 965340, response_b: true },
        {
          id: 970328,
          parent_id: 965341,
          respondant_comment: "",
          response_d: true,
        },
        { id: 970329, parent_id: 965342, response_d: true },
        { id: 970330, parent_id: 965343, response_b: true },
        { id: 970331, parent_id: 965344, response_c: true },
        { id: 970332, parent_id: 965345, response_b: true },
        { id: 970333, parent_id: 965346, response_d: true },
        { id: 970334, parent_id: 965347, response_d: true },
        { id: 970335, parent_id: 965348, response_d: true },
        { id: 970336, parent_id: 965349, response_d: true },
      ],
    },
  ],
  departments: [
    { id: 1, name: "accounting" },
    { id: 2, name: "accounting \u0026 finance" },
    { id: 3, name: "admin and dispatch" },
    { id: 4, name: "bt" },
    { id: 5, name: "business analytics" },
    { id: 6, name: "c\u0026i sales" },
    { id: 7, name: "carrier relations" },
    { id: 8, name: "collections" },
    { id: 9, name: "credit" },
    { id: 10, name: "credit/collections" },
    { id: 11, name: "crm" },
    { id: 12, name: "customer service" },
    { id: 13, name: "dedicated billers" },
    { id: 14, name: "def" },
    { id: 15, name: "def ops" },
    { id: 16, name: "erp" },
    { id: 17, name: "fleet card" },
    { id: 18, name: "follow up" },
    { id: 19, name: "fs\u0026s projects" },
    { id: 20, name: "fs\u0026s services" },
    { id: 21, name: "ftl dispatch" },
    { id: 22, name: "fuels - dallas" },
    { id: 23, name: "fuels - houston" },
    { id: 24, name: "fuels - so. texas" },
    { id: 25, name: "fuels - tyler" },
    { id: 26, name: "fuels - west texas" },
    { id: 27, name: "government" },
    { id: 28, name: "human resources" },
    { id: 29, name: "illinois office" },
    { id: 30, name: "inventory" },
    { id: 31, name: "ltl pre invoice" },
    { id: 32, name: "ltl product" },
    { id: 33, name: "lubes - dallas" },
    { id: 34, name: "lubes - houston" },
    { id: 35, name: "lubes - shell facility" },
    { id: 36, name: "lubes - tyler" },
    { id: 37, name: "lubes - west texas" },
    { id: 38, name: "marketing" },
    { id: 39, name: "moc corporate admin" },
    { id: 40, name: "mpg house account" },
    { id: 41, name: "mpg retail" },
    { id: 42, name: "mpg wholesale" },
    { id: 43, name: "north admin" },
    { id: 44, name: "north ftl" },
    { id: 45, name: "north ltl" },
    { id: 46, name: "offsite equipment - dallas, houston, west texas" },
    { id: 47, name: "ohv admin" },
    { id: 48, name: "ohv ftl" },
    { id: 49, name: "ohv ltl" },
    { id: 50, name: "ohv maintenance" },
    { id: 51, name: "oms" },
    { id: 52, name: "ondemand" },
    { id: 53, name: "orp corporate admin" },
    { id: 54, name: "oss" },
    { id: 55, name: "payables" },
    { id: 56, name: "prof support - entinuum implement" },
    { id: 57, name: "risk \u0026 analysis" },
    { id: 58, name: "sales operations" },
    { id: 59, name: "select - beaumont, tyler, west texas" },
    { id: 60, name: "select - dallas" },
    { id: 61, name: "select - houston" },
    { id: 62, name: "strategic accounts" },
    { id: 63, name: "supply" },
    { id: 64, name: "tax accounting" },
    { id: 65, name: "wf admin" },
    { id: 66, name: "wf fuel" },
    { id: 67, name: "wf service" },
    { id: 68, name: "wholesale fuels market" },
    { id: 69, name: "admin" },
    { id: 70, name: "design" },
    { id: 71, name: "engineering" },
    { id: 72, name: "estimating" },
    { id: 73, name: "externals" },
    { id: 74, name: "finance" },
    { id: 75, name: "internals" },
    { id: 76, name: "loading" },
    { id: 77, name: "maintenance" },
    { id: 78, name: "management" },
    { id: 79, name: "materials handling" },
    { id: 80, name: "modesto floors" },
    { id: 81, name: "process" },
    { id: 82, name: "production management" },
    { id: 83, name: "production support" },
    { id: 84, name: "quality and safety" },
    { id: 85, name: "ripon" },
    { id: 86, name: "sales \u0026 marketing" },
    { id: 87, name: "saw" },
    { id: 88, name: "site services" },
    { id: 89, name: "specials" },
    { id: 90, name: "stairs" },
    { id: 91, name: "survey" },
    { id: 92, name: "technical" },
    { id: 93, name: "technical support" },
    { id: 94, name: "accounting, legal \u0026 compliance" },
    { id: 95, name: "automation" },
    { id: 96, name: "brand management" },
    { id: 97, name: "commercial sales" },
    { id: 98, name: "executive officers" },
    { id: 99, name: "information technology" },
    { id: 100, name: "manufacturing engineering" },
    { id: 101, name: "manufacturing operations" },
    { id: 102, name: "mile sales" },
    { id: 103, name: "new product development" },
    { id: 104, name: "procurement" },
    { id: 105, name: "quality assurance" },
    { id: 106, name: "account executive" },
    { id: 107, name: "operations" },
    { id: 108, name: "recruiter" },
    { id: 109, name: "sourcer" },
    { id: 110, name: "account management" },
    { id: 111, name: "analytics" },
    { id: 112, name: "care management" },
    { id: 113, name: "medical assistants" },
    { id: 114, name: "medical assistants-troup cty" },
    { id: 115, name: "personal importation programs" },
    { id: 116, name: "pharmacy programs" },
    { id: 117, name: "providers" },
    { id: 118, name: "providers-troup cty" },
    { id: 119, name: "providers-uafs" },
    { id: 120, name: "client services" },
    { id: 121, name: "sales" },
  ],
  company_positions: [
    { id: 518, name: "recruiter" },
    { id: 519, name: "account executive" },
    { id: 520, name: "operations" },
    { id: 521, name: "sourcer" },
    { id: 522, name: "survery taker" },
    { id: 523, name: "management" },
    { id: 524, name: "admin" },
  ],
  completion_progress: { complete: 23, incomplete: 1, is_complete: false },
  genders: {
    0: "unknown",
    1: "male",
    2: "female",
    3: "declined",
    4: "other",
    5: "genderqueer",
    6: "non-binary",
    7: "polygender",
    8: "genderfluid",
    9: "agender",
    10: "bigender",
  },
  ethnicities: {
    0: "unknown",
    1: "hispanic or latino",
    2: "not hispanic or latino",
  },
  races: {
    0: "unknown",
    1: "white",
    2: "black or african american",
    3: "two or more",
    4: "asian",
    5: "american indian or alaska native",
    6: "native hawaiian or pacific islander",
  },
};
